export enum PhoneType {
  Home = 1,
  Work = 2,
  Mobile = 3
}
